
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexmyylDgbPZ5SJH2C1_ikOSjtyFCebb1sQKv4jwD0RKw4Meta } from "/tmp/tmpbjf9vqr6/pages/[area]/[pref]/[id]/index.vue?macro=true";
import { default as indexMueUX5LRJrV5pyvTsH2SSbuIRitGmmX8gPt9z1vmiEQMeta } from "/tmp/tmpbjf9vqr6/pages/[area]/[pref]/index.vue?macro=true";
import { default as index10P66_45FCzzdMyqL4uLimdidDkG0OH_V2lgY6OY1qsMgMeta } from "/tmp/tmpbjf9vqr6/pages/[area]/index.vue?macro=true";
import { default as index063f2_GzAXqeoH_45Eow63PUXjIZMkIfY_p3qmXVG6OKAMeta } from "/tmp/tmpbjf9vqr6/pages/index.vue?macro=true";
import { default as indexe3gq__45wU9tZcGLY4n4XMDK3Cj20S3HFhsKB8dztUiKQMeta } from "/tmp/tmpbjf9vqr6/pages/okinawa/[id]/index.vue?macro=true";
import { default as indexndC_45cQIbhtosL9wkOR4Prdr_45x3Zp7CIjMjxwzjmAMDAMeta } from "/tmp/tmpbjf9vqr6/pages/okinawa/index.vue?macro=true";
import { default as index22tLVS5PXClRIbusfQTJXM_45V7zaX8OWIcjxLqGuV_z0Meta } from "/tmp/tmpbjf9vqr6/pages/zoom-map/index.vue?macro=true";
export default [
  {
    name: "area-pref-id",
    path: "/:area()/:pref()/:id()",
    component: () => import("/tmp/tmpbjf9vqr6/pages/[area]/[pref]/[id]/index.vue")
  },
  {
    name: "area-pref",
    path: "/:area()/:pref()",
    component: () => import("/tmp/tmpbjf9vqr6/pages/[area]/[pref]/index.vue")
  },
  {
    name: "area",
    path: "/:area()",
    component: () => import("/tmp/tmpbjf9vqr6/pages/[area]/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/tmpbjf9vqr6/pages/index.vue")
  },
  {
    name: "okinawa-id",
    path: "/okinawa/:id()",
    component: () => import("/tmp/tmpbjf9vqr6/pages/okinawa/[id]/index.vue")
  },
  {
    name: "okinawa",
    path: "/okinawa",
    component: () => import("/tmp/tmpbjf9vqr6/pages/okinawa/index.vue")
  },
  {
    name: "zoom-map",
    path: "/zoom-map",
    component: () => import("/tmp/tmpbjf9vqr6/pages/zoom-map/index.vue")
  }
]